import React from "react";

function MainImage() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 525 363"
        >
            <path
                fill="#EFEFEF"
                d="M101.057 363C45.719 363 .854 357.496.854 350.707s44.865-12.285 100.203-12.285c55.339 0 100.203 5.504 100.203 12.285 0 6.781-44.864 12.285-100.203 12.285M414.901 363c-39.677 0-71.844-5.504-71.844-12.293s32.167-12.285 71.844-12.285c39.677 0 71.844 5.504 71.844 12.285 0 6.781-32.167 12.285-71.844 12.285"
            ></path>
            <g clipPath="url(#clip0_0_135)">
                <path
                    fill="#F79D8C"
                    fillRule="evenodd"
                    d="M163.036 38.255c-6.016 1.644-9.956 5.677-14.385 9.693-.123.111-1.899 1.896-2.088 1.802-4.363-2.107-3.946-2.354-6.316-6.423-1.006-1.72-1.811-3.252-3.523-5.542-.029-.04-1.046-1.45-2.317-4.103-.988-2.067 4.87-2.76 7.022-3.693 3.294-1.427 8.551-5.754 9.157-7.521.518-1.52 6.534-2.307 7.146-.564 1.676 4.78 1.682 12.64 5.31 16.345l-.006.006z"
                    clipRule="evenodd"
                ></path>
                <mask
                    id="mask0_0_135"
                    style={{ maskType: "luminance" }}
                    width="30"
                    height="30"
                    x="134"
                    y="20"
                    maskUnits="userSpaceOnUse"
                >
                    <path
                        fill="#fff"
                        d="M163.036 38.255c-6.016 1.644-9.956 5.677-14.385 9.693-.123.111-1.899 1.896-2.088 1.802-4.363-2.107-3.946-2.354-6.316-6.423-1.006-1.72-1.811-3.252-3.523-5.542-.029-.04-1.046-1.45-2.317-4.103-.988-2.067 4.87-2.76 7.022-3.693 3.294-1.427 8.551-5.754 9.157-7.521.518-1.52 6.534-2.307 7.146-.564 1.676 4.78 1.682 12.64 5.31 16.345l-.006.006z"
                    ></path>
                </mask>
                <g mask="url(#mask0_0_135)">
                    <path
                        fill="#F69585"
                        fillRule="evenodd"
                        d="M151.398 45.476c-.571-1.779-1.112-3.587-1.324-5.436-.205-1.79-.105-3.705-.647-5.454-.711-2.313-2.593-3.787-2.775-6.323-.206-2.877 1.17-5.683 2.628-8.05.195-.31.383-.622.577-.927.1-.153 2.829-3.423 2.94-3.276.253.329 2.435-1.174 3.958 2.894.7 1.861 1.018 8.226.947 10.151-.17 4.568-3.711 1.262-2.593 7.151.247 1.315 1.84 7.35.841 8.577-.812.993-3.359.4-4.558.693h.006z"
                        clipRule="evenodd"
                    ></path>
                </g>
                <path
                    fill="#041839"
                    fillRule="evenodd"
                    d="M137.977 295.437c1.112-9.235-14.832-14.689-14.026.734.282 5.418.87 39.153 1.223 39.229 0 0-2.182 6.699-1.735 16.544l6.875.018-.065-2.847s4.511 1.996 12.439 3.205c6.851 1.045 8.974.734 12.815.405 1.982-.17 3.605-4.28 1.752-5.254-4.169-2.196-6.71-2.495-10.727-4.509-3.905-1.955-7.392-3.617-9.751-7.362-.188-.3-.311-27.652 1.194-40.163h.006zM52.39 291.474c3.587-8.789-11.074-18.259-14.38-2.895-1.158 5.396-9.58 38.702-9.238 38.866 0 0-4 6.018-6.176 15.81l6.946 1.791.694-2.812s4.028 3.123 11.727 6.358c6.651 2.795 8.88 3.035 12.85 3.699 2.046.34 4.793-3.276 3.181-4.715-3.634-3.235-6.116-4.186-9.644-7.197-3.43-2.93-6.51-5.46-7.893-9.752-.112-.341 7.07-27.247 11.933-39.159v.006z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#003A52"
                    fillRule="evenodd"
                    d="M113.159 140.239s22.472 73.292 26.653 88.651c3.558 13.063-1.047 103.968-1.047 103.968l-15.849.012s-6.24-72.113-12.462-97.968c-4.958-20.607-24.86-57.16-24.86-57.16l-6.345-43.345 33.904 5.842h.006z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#003A52"
                    fillRule="evenodd"
                    d="M95.751 141.307l-5.693 29.877s-7.722 62.027-11.556 72.671c-3.47 9.622-34.393 87.083-34.393 87.083l-17.531-5.137s20.342-83.22 21.754-89.273c1.717-7.374 2.535-38.66 1.923-51.964-.47-10.168 2.447-39.546 10.921-53.548l34.575 10.291z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#6D97CF"
                    fillRule="evenodd"
                    d="M136.148 66.928s51.848 14.044 55.417 16.504c7.822 5.407 36.775 23.055 47.919 31.797l7.769-10.967s-32.957-29.478-46.084-37.98c-8.463-5.483-38.497-16.197-55.235-19.878l-9.78 20.524h-.006z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#6D97CF"
                    fillRule="evenodd"
                    d="M59.518 132.313c-5.035-6.153 25.277-85.187 48.366-100.669 5.881-3.945 11.591-5.23 15.978-5.107 8.322.234 15.885 3.457 15.897 3.534.265 1.685-1.723 5.982 1.858 10.567 2.294 2.936 8.998 3.47 9.816 4.826 2.158 3.576-18.461 55.804-19.231 57.993-9.533 27.095-6.363 44.291-15.579 45.582-17.355 2.437-48.913-6.704-57.111-16.72l.006-.006z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#073553"
                    fillRule="evenodd"
                    d="M137.013 46.022a2.057 2.057 0 01.846-2.401l2.294-1.444a2.057 2.057 0 011.647-.241 2.06 2.06 0 011.288 1.05c.353.694.735 1.451 1.058 2.097a2.054 2.054 0 01-.564 2.542l-4.746 3.71s-1.129-3.293-1.818-5.313h-.005z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#073553"
                    fillRule="evenodd"
                    d="M139.218 45.8s-9.322 23.46-13.209 32.83c-6.463 15.557-19.066 48.264-19.066 48.264l4.804 8.073 8.822-4.351s9.398-37.533 12.897-51.394c2.676-10.603 8.063-31.662 8.098-31.79.847-3.165-2.346-1.627-2.346-1.627v-.006z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#6C849C"
                    fillRule="evenodd"
                    d="M236.544 252.373l-11.01 83.074c-11.274-3.035-29.599-24.728-21.624-52.592 4.563-15.957 15.396-26.29 32.634-30.482z"
                    clipRule="evenodd"
                ></path>
                <mask
                    id="mask1_0_135"
                    style={{ maskType: "luminance" }}
                    width="36"
                    height="84"
                    x="201"
                    y="252"
                    maskUnits="userSpaceOnUse"
                >
                    <path
                        fill="#fff"
                        d="M236.544 252.373l-11.01 83.074c-11.274-3.035-29.599-24.728-21.624-52.592 4.563-15.957 15.396-26.29 32.634-30.482z"
                    ></path>
                </mask>
                <g mask="url(#mask1_0_135)">
                    <path
                        fill="#A0ADBB"
                        fillRule="evenodd"
                        d="M218.724 341.388l12.697-96.159 11.968 5.735-10.103 93.853-14.562-3.429z"
                        clipRule="evenodd"
                    ></path>
                </g>
                <path
                    fill="#F16570"
                    fillRule="evenodd"
                    d="M228.557 254.651c-33.91-58.175-61.239-119.367-71.237-139.769-3.629-7.397 5.175-11.09 7.833-6.939 18.002 28.133 44.508 81.952 70.926 143.72 0 0-6.163 5.307-7.522 2.983v.005z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#F16570"
                    fillRule="evenodd"
                    d="M240.561 253.025c6.069-67.034 4.904-134.021 5.322-156.73.153-8.237-9.392-7.867-10.039-2.977-4.393 33.095-5.599 93.055-3.364 160.183 0 0 7.839 2.207 8.081-.476z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#F79D8C"
                    fillRule="evenodd"
                    d="M145.281 136.299c-2.493-.428 4.57 2.625 13.774 3.611 4.934.528 10.456-.599 12.926-1.01 3.017-.505 5.276-.563 6.975-3.299 1.259-2.026.7-9.787-.947-11.965-1.429-1.891-7.839-6.664-9.991-5.889-2.606.945-5.97 2.079-6.764 4.785-.847 2.889-3.475 5.29-8.239 3.951-3.023-.845-7.728 9.811-7.728 9.811l-.006.005z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#6D97CF"
                    fillRule="evenodd"
                    d="M114.023 41.695s-4.334 48.658-2.14 52.533c4.81 8.49 34.745 26.86 46.131 31.762l-4.952 14.73s-40.562-12.2-56.147-29.73c-5.922-6.664-8.404-45.16-3.281-58.903L114.018 41.7l.005-.006z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#F79D8C"
                    fillRule="evenodd"
                    d="M160.213 45.118c3.017 3.405 4.052 3.305 5.558 2.448.382-.217 1.353-.898 1.558-1.356.23-.51.547-1.714 1.041-2.031.383-.247 1.212.399 1.582.146.547-.364.724-.246 1.047-.534 1.412-1.244 1.341-1.608 1.382-1.597.518.147.635.587 1.488 1.221.412.3 1.247 1.116 1.706-.07 1.158-2.977 1.123-4.69 2.346-6.934.63-1.156 2.117-1.696 3.053-2.595 4.234-4.086 7.345-9.487 4.64-15.364-7.763-16.873-29.37-4.75-31.364 8.137-.847 5.466 4.158 13.427 5.963 18.523v.006z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#F04D26"
                    fillRule="evenodd"
                    d="M162.201 20.56s-1.47.734-1.676 2.372c-.106.857.271 2.23.747 3.335 0 0-.282-1.61-.218-2.907.053-1.086.824-2.23 1.147-2.8zM162.877 26.067c-.299-1.069-1.182-2.994.224-2.76.147.024 1.494.382 1.6.517.047.059-.988.317-1.024.34-.476.37-.688 1.257-.8 1.897v.006zM162.225 22.18c.247-.27.552-.593.923-.663.635-.117 1.788.663 2.058-.206.077-.246-.023-.575-.164-.792-.206-.311-.535-.482-.871-.564a2.52 2.52 0 00-1.446.094c-.024.006-.165.07-.171.065-.053-.047.747-.493.935-.576.682-.31 1.717-.475 2.382.147 1.07 1.004 0 3.253-1.229 3.223-.665-.011-1.835-.381-2.411-.728h-.006z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#041839"
                    fillRule="evenodd"
                    d="M167.282 40.95c-.764.44.794 3.546-.123 5.718-.259.605-.953.969-1.735 1.32-3.093 1.398-5.34-.621-6.316-1.596-2.2-2.196-3.541-8.59-3.323-11.718.112-1.597.623-3.975 1.852-5.096 1-.916 2.553-1.21 3.817-1.568 2.941-.834 5.14-2.272 6.234-5.436.3-.875.088-2.8-.964-3.728-3.441-3.041-6.875.381-9.228 4.25-1.264 2.073-8.063 2.096-8.574 1.204-.818-1.433-.194-2.413.288-4.028.559-1.872.67-2.137 1.223-3.188.765-1.461 1.847-3.399 3.058-5.477 2.123-3.658 3.5-5.724 7.593-8.454 2.482-1.662 5.457-3.288 8.557-3.141 3.099.14 6.287 1.256 8.862 3 4.611 3.123 7.299 7.48 9.551 12.382.859 1.872 1.712 3.704 2.888 5.4.441.635 2.17 1.856 2.023 2.73-.147.87-1.523 1.985-2.911 2.496-1.688.628-3.335.963-5.152-.804-.459-.447-2.052-3.265-2.411-3.306-1.529-.176-2.429 2.178-3.499 2.918-.877.605-2.006.505-3.023.558-3.005.158-5.587 1.532-7.54 3.822-1.429 1.679-2.576 3.728-2.482 5.947.183 4.31 2.753 3.546 5.323 5.8.511.447 1.158 1.251 1.2 1.644.047.429-.7 1.128-1.524 1.45-1.052.412-2.934-3.516-3.658-3.093l-.006-.006z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#000"
                    fillRule="evenodd"
                    d="M146.599 315.68l-28.171.417.241 16.239 28.171-.417-.241-16.239z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#000"
                    fillRule="evenodd"
                    d="M156.873 326.999l-.194-6.869-13.727.381.194 6.869 13.727-.381zM174.41 323.3l.183 2.965 7.404-.458-.188-2.965-7.399.458zM201.469 322.255l.053 2.965 7.416-.129-.053-2.965-7.416.129zM228.828 321.797l.053 2.971 7.416-.135-.053-2.965-7.416.129zM281.334 315.075l.553 2.912 7.286-1.374-.552-2.918-7.287 1.38zM254.305 319.237l.447 2.93 7.333-1.11-.453-2.935-7.327 1.115zM308.399 309.774l.488 2.929 7.316-1.215-.488-2.93-7.316 1.216zM334.969 304.073l.841 2.841 7.11-2.096-.841-2.841-7.11 2.096z"
                    clipRule="evenodd"
                ></path>
                <path
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="5.03"
                    d="M160.496 318.404a3.064 3.064 0 00-3.117 3.012c-.024 1.385-.047 3.017-.071 4.403-.012.81.3 1.597.865 2.178a3.094 3.094 0 002.152.933c3.158.053 8.057.129 11.215.182a3.064 3.064 0 003.117-3.011c.024-1.386.047-3.018.071-4.404.012-.81-.3-1.597-.865-2.178a3.094 3.094 0 00-2.152-.933c-3.158-.053-8.057-.129-11.215-.182zm25.794.329a3.065 3.065 0 00-2.929 3.193c.059 1.386.136 3.018.194 4.404.036.81.394 1.573.994 2.125.6.546 1.394.833 2.206.798 3.158-.141 8.051-.358 11.203-.493a3.066 3.066 0 002.929-3.194c-.059-1.385-.135-3.017-.194-4.403a3.074 3.074 0 00-.994-2.125 3.083 3.083 0 00-2.206-.799c-3.158.141-8.051.359-11.203.494zm26.218-.693a3.065 3.065 0 00-2.929 3.194c.059 1.385.135 3.017.194 4.403.035.81.394 1.573.994 2.119.6.546 1.394.834 2.205.799 3.159-.141 8.052-.359 11.204-.494a3.066 3.066 0 002.929-3.193c-.059-1.386-.136-3.018-.194-4.404a3.074 3.074 0 00-.994-2.125 3.078 3.078 0 00-2.206-.798c-3.158.141-8.051.358-11.203.493v.006zm27.17-1.034a3.061 3.061 0 00-2.711 3.376c.153 1.38.33 3 .482 4.38a3.057 3.057 0 003.382 2.706c3.141-.346 8.01-.88 11.151-1.227a3.06 3.06 0 002.711-3.375l-.483-4.38a3.062 3.062 0 00-3.381-2.707c-3.141.347-8.01.881-11.151 1.227zm52.212-7.878a3.06 3.06 0 00-2.452 3.569l.806 4.333a3.07 3.07 0 001.276 1.967c.67.458 1.494.634 2.294.487l11.027-2.043a3.06 3.06 0 002.452-3.57l-.806-4.332a3.063 3.063 0 00-3.57-2.454l-11.027 2.043zm-26.6 3.452a3.064 3.064 0 00-2.552 3.499c.218 1.368.471 2.982.688 4.35a3.027 3.027 0 001.223 1.996 3.096 3.096 0 002.282.552c3.123-.487 7.957-1.25 11.08-1.738a3.065 3.065 0 002.553-3.499c-.218-1.368-.471-2.982-.689-4.35a3.022 3.022 0 00-1.223-1.996 3.094 3.094 0 00-2.282-.552c-3.123.487-7.957 1.25-11.08 1.738zm53.677-9.364a3.055 3.055 0 00-2.358 3.628l.917 4.309a3.083 3.083 0 001.329 1.932c.682.44 1.512.593 2.306.428 3.087-.657 7.88-1.673 10.974-2.331a3.056 3.056 0 002.358-3.628l-.917-4.309a3.084 3.084 0 00-1.33-1.932 3.098 3.098 0 00-2.305-.428c-3.088.657-7.881 1.673-10.974 2.331zm32.557 7.855c-1.335 2.131-5.051-.898-7.033-3.476-2.241-2.912-2.917-7.99 2.035-11.084 1.323-.828 5.328-3.605 5.987-1.691.835 2.425.352 14.126-.989 16.257v-.006z"
                ></path>
                <path
                    fill="#000"
                    fillRule="evenodd"
                    d="M350.137 298.137l-.053 8.366 11.209.071.053-8.366-11.209-.071z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#000"
                    fillRule="evenodd"
                    d="M355.682 254.616c9.234-46.022 54.189-75.893 100.331-66.67 46.143 9.223 76.107 54.077 66.88 100.099-9.233 46.022-54.188 75.894-100.331 66.67-46.143-9.223-76.107-54.077-66.88-100.099z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#fff"
                    d="M374.937 284.399l9.022-46.486 10.486 2.026c5.998 1.162 10.35 3.728 13.044 7.708 3.546 5.202 4.558 11.719 3.034 19.545-1.493 7.708-4.504 13.297-9.027 16.779-3.858 2.959-8.922 3.834-15.197 2.618l-11.362-2.195v.005zm14.326-8.882c4.393.622 7.322-2.83 8.781-10.357.723-3.71.735-6.751.047-9.111-.688-2.384-1.97-3.758-3.858-4.122l-.377-.07-4.593 23.666v-.006zM411.206 291.415l9.015-46.486 22.578 4.368-2.117 10.926-10.434-2.014-1.311 6.775 9.351 1.808-2.041 10.504-9.351-1.809-1.376 7.11 10.427 2.014-2.17 11.172-22.571-4.368zM438.964 296.781l9.022-46.486 14.126 2.73c5.281 1.022 8.963 2.983 11.039 5.883 2.105 2.971 2.776 6.411 2.017 10.321-1.129 5.818-4.54 8.431-10.221 7.832 3.093 1.098 5.216 2.63 6.375 4.608 1.158 1.973 1.429 4.545.817 7.715-.776 3.992-2.652 6.963-5.628 8.906-2.958 1.967-6.469 2.56-10.527 1.773l-17.014-3.288-.006.006zm14.103-7.738c.229.065.429.118.606.165.17.041.317.076.435.099 1.517.294 2.805.118 3.864-.534 1.064-.646 1.729-1.667 1.999-3.047.271-1.385.03-2.554-.723-3.511-.753-.957-1.911-1.591-3.488-1.89l-.958-.188-1.729 8.912-.006-.006zm3.558-18.335l.818.159c1.458.282 2.675.153 3.658-.388.982-.54 1.593-1.438 1.84-2.706.524-2.689-.647-4.309-3.499-4.861a28.096 28.096 0 00-1.264-.182l-1.547 7.978h-.006zM490.435 306.738l-12.144-2.348 6.857-35.349-6.698-1.292 2.158-11.143 25.812 4.997-2.164 11.137-6.957-1.345-6.864 35.343z"
                ></path>
                <path
                    fill="#6C849C"
                    fillRule="evenodd"
                    d="M235.35 252.297l35.486 77.127c10.427-6.188 22.448-32.449 6.246-57.083-9.28-14.108-23.189-20.971-41.732-20.05v.006z"
                    clipRule="evenodd"
                ></path>
                <mask
                    id="mask2_0_135"
                    style={{ maskType: "luminance" }}
                    width="51"
                    height="78"
                    x="235"
                    y="252"
                    maskUnits="userSpaceOnUse"
                >
                    <path
                        fill="#fff"
                        d="M235.35 252.297l35.486 77.127c10.427-6.188 22.448-32.449 6.246-57.083-9.28-14.108-23.189-20.971-41.732-20.05v.006z"
                    ></path>
                </mask>
                <g mask="url(#mask2_0_135)">
                    <path
                        fill="#A0ADBB"
                        fillRule="evenodd"
                        d="M279.417 333.199l-41.032-89.286-10.328 9.001 37.745 87.805 13.615-7.52z"
                        clipRule="evenodd"
                    ></path>
                </g>
                <path
                    fill="#6C849C"
                    fillRule="evenodd"
                    d="M234.979 243.432c5.211-.693 10.01 2.965 10.71 8.172.694 5.202-2.97 9.993-8.187 10.691-5.21.693-10.009-2.964-10.709-8.166-.694-5.202 2.97-9.992 8.186-10.691v-.006z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#A0ADBB"
                    fillRule="evenodd"
                    d="M235.662 248.546a4.36 4.36 0 014.899 3.739 4.355 4.355 0 01-3.747 4.891 4.36 4.36 0 01-4.899-3.74 4.355 4.355 0 013.747-4.89z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#F79D8C"
                    fillRule="evenodd"
                    d="M249.853 104.544c1.723.258 1.335 1.62.535 3.158-.435.84-.435 1.615-3.641.945-2.858-.593-7.557-.135-8.221-1.544-.635-1.338-.43-2.965 1.682-3.135 2.076-.17 5.128-.076 5.322-.064 1.782.111 3.093.458 4.328.645l-.005-.005z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#F79D8C"
                    fillRule="evenodd"
                    d="M239.12 111.988c.811.663 3.746.399 5.398.657 2.153.335 3.659.482 4.135-.023.523-.564 1.129-2.067.717-3.129-.194-.505-5.081-1.221-7.057-.945-.894.123-2.746.493-3.329 1.215-.617.775-.57 1.65.136 2.225zM240.743 102.647c.794.787 4.34 1.051 6.057 1.433 2.5.558 3.353.734 4.017.593.771-.171.888-2.266 1.047-3.329.241-1.656-5.222-1.973-7.322-1.99-.947-.006-2.929.094-3.599.739-.718.687-.888 1.879-.2 2.56v-.006z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#F79D8C"
                    fillRule="evenodd"
                    d="M241.184 115.516c1.435.276 4.781 1.644 5.94 1.398 1.394-.3 2.058-3.03 0-3.822-.718-.276-2.459-.441-3.782-.458-.788-.012-1.923-.024-2.693.041-1.765.141-.453 2.653.535 2.847v-.006z"
                    clipRule="evenodd"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0_0_135">
                    <path
                        fill="#fff"
                        d="M0 0H501.961V356.383H0z"
                        transform="translate(22.596)"
                    ></path>
                </clipPath>
            </defs>
        </svg>
    );
}

export default MainImage;
